import { render, staticRenderFns } from "./EditProfilePc.vue?vue&type=template&id=67c60078&scoped=true&"
import script from "./EditProfilePc.vue?vue&type=script&lang=js&"
export * from "./EditProfilePc.vue?vue&type=script&lang=js&"
import style0 from "./EditProfilePc.vue?vue&type=style&index=0&id=67c60078&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c60078",
  null
  
)

export default component.exports